import * as Updates from 'expo-updates'
import Constants from 'expo-constants'

const systemEnv = Constants.manifest?.extra?.env

const defaultEnv = {
  AUTH0_CLIENT_ID: systemEnv?.AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: systemEnv?.AUTH0_DOMAIN,
  SENTRY_AUTH_TOKEN: systemEnv?.SENTRY_AUTH_TOKEN,
  SENTRY_DSN: systemEnv?.SENTRY_DSN,
}

export default function env () {
  if (__DEV__) {
    return {
      ...defaultEnv,
      GQL_URL: systemEnv?.DEVELOPMENT_GQL_URL,
      API_URL: systemEnv?.DEVELOPMENT_API_URL,
      BUILD_TARGET: systemEnv?.BUILD_TARGET || 'development',
    }
  } else if (
    Updates.releaseChannel.startsWith('staging') ||
    Updates.releaseChannel.startsWith('pr-')
  ) {
    return {
      ...defaultEnv,
      GQL_URL: systemEnv?.STAGING_GQL_URL,
      API_URL: systemEnv?.STAGING_API_URL,
      BUILD_TARGET: 'staging',
    }
  } else if (
    Updates.releaseChannel === 'default' ||
    Updates.releaseChannel.startsWith('prod') ||
    Updates.releaseChannel.startsWith('V')
  ) {
    return {
      ...defaultEnv,
      GQL_URL: systemEnv?.PRODUCTION_GQL_URL,
      API_URL: systemEnv?.PRODUCTION_API_URL,
      BUILD_TARGET: 'production',
    }
  } else {
    /* Default to production */
    return {
      ...defaultEnv,
      GQL_URL: systemEnv?.PRODUCTION_GQL_URL,
      API_URL: systemEnv?.PRODUCTION_API_URL,
      BUILD_TARGET: systemEnv?.BUILD_TARGET || 'unknown',
    }
  }
}
